import { prefetchInfiniteTransactions } from "@/api/transactions";
import { seo } from "@/utils/seo";
import { createFileRoute } from "@tanstack/react-router";
import { WalletController } from "./WalletController";

export const Route = createFileRoute("/_auth/_app/wallet/")({
  loader: async () => {
    prefetchInfiniteTransactions();
  },

  component: WalletController,
  head: () => ({ meta: seo({ title: "Wallet" }) }),
});
